import React from 'react';
import { Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import { format, isValid } from 'date-fns';

interface ICaseCardProps {
  caseData: any;
}

const CaseCard: React.FC<ICaseCardProps> = (props: ICaseCardProps) => {
  const { caseData } = props;
  const resolveDisplayDate = () => {
    const dateCandidates = [
      caseData?.date,
      caseData?.lastUpdate,
      caseData?.createdAt,
    ];

    const validDate = dateCandidates
      .map((candidate) => new Date(candidate))
      .find((candidate) => isValid(candidate));

    if (!validDate) {
      return 'N/A';
    }

    const dtWithoutTz = new Date(
      validDate.valueOf() + validDate.getTimezoneOffset() * 60 * 1000,
    );

    return format(dtWithoutTz, 'yyyy-MM-dd');
  };

  const formatted_dt = resolveDisplayDate();

  const bulkIcon = (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
    >
      <path
        d='M12 15H6C5.40326 15 4.83097 14.7629 4.40901 14.341C3.98705 13.919 3.75 13.3467 3.75 12.75V5.25C3.75 5.05109 3.67098 4.86032 3.53033 4.71967C3.38968 4.57902 3.19891 4.5 3 4.5C2.80109 4.5 2.61032 4.57902 2.46967 4.71967C2.32902 4.86032 2.25 5.05109 2.25 5.25V12.75C2.25 13.7446 2.64509 14.6984 3.34835 15.4017C4.05161 16.1049 5.00544 16.5 6 16.5H12C12.1989 16.5 12.3897 16.421 12.5303 16.2803C12.671 16.1397 12.75 15.9489 12.75 15.75C12.75 15.5511 12.671 15.3603 12.5303 15.2197C12.3897 15.079 12.1989 15 12 15ZM7.5 9.75C7.5 9.94891 7.57902 10.1397 7.71967 10.2803C7.86032 10.421 8.05109 10.5 8.25 10.5H12C12.1989 10.5 12.3897 10.421 12.5303 10.2803C12.671 10.1397 12.75 9.94891 12.75 9.75C12.75 9.55109 12.671 9.36032 12.5303 9.21967C12.3897 9.07902 12.1989 9 12 9H8.25C8.05109 9 7.86032 9.07902 7.71967 9.21967C7.57902 9.36032 7.5 9.55109 7.5 9.75ZM15.75 6.705C15.7422 6.6361 15.7271 6.56822 15.705 6.5025V6.435C15.6689 6.35788 15.6208 6.287 15.5625 6.225L11.0625 1.725C11.0005 1.66666 10.9296 1.61856 10.8525 1.5825C10.8301 1.57932 10.8074 1.57932 10.785 1.5825C10.7088 1.53881 10.6247 1.51076 10.5375 1.5H7.5C6.90326 1.5 6.33097 1.73705 5.90901 2.15901C5.48705 2.58097 5.25 3.15326 5.25 3.75V11.25C5.25 11.8467 5.48705 12.419 5.90901 12.841C6.33097 13.2629 6.90326 13.5 7.5 13.5H13.5C14.0967 13.5 14.669 13.2629 15.091 12.841C15.5129 12.419 15.75 11.8467 15.75 11.25V6.75C15.75 6.75 15.75 6.75 15.75 6.705ZM11.25 4.0575L13.1925 6H12C11.8011 6 11.6103 5.92098 11.4697 5.78033C11.329 5.63968 11.25 5.44891 11.25 5.25V4.0575ZM14.25 11.25C14.25 11.4489 14.171 11.6397 14.0303 11.7803C13.8897 11.921 13.6989 12 13.5 12H7.5C7.30109 12 7.11032 11.921 6.96967 11.7803C6.82902 11.6397 6.75 11.4489 6.75 11.25V3.75C6.75 3.55109 6.82902 3.36032 6.96967 3.21967C7.11032 3.07902 7.30109 3 7.5 3H9.75V5.25C9.75203 5.50586 9.79768 5.75949 9.885 6H8.25C8.05109 6 7.86032 6.07902 7.71967 6.21967C7.57902 6.36032 7.5 6.55109 7.5 6.75C7.5 6.94891 7.57902 7.13968 7.71967 7.28033C7.86032 7.42098 8.05109 7.5 8.25 7.5H14.25V11.25Z'
        fill='var(--alternative-text-color)'
      />
    </svg>
  );

  const scoreIcon = (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='12'
      viewBox='0 0 20 12'
      fill='none'
    >
      <path
        d='M18.8629 11.25H1.13711C1.06117 11.25 1 11.1862 1 11.1078V9.95818C1 9.61444 1.0232 9.27107 1.0682 8.93026C1.07945 8.8446 1.09141 8.75894 1.10441 8.67364C1.41063 6.63457 2.27441 4.88711 3.6884 3.43891C4.97512 2.12085 6.51039 1.26498 8.29141 0.925252C10.964 0.415667 13.3979 1.01602 15.5452 2.74416C17.2643 4.12747 18.3412 5.95039 18.8066 8.15458C18.885 8.52638 18.9128 8.90948 18.9655 9.28711V9.28894C18.9849 9.49598 18.9989 9.75879 19 9.78066C19 9.78175 19 9.78248 19 9.78358V11.1075C19 11.1862 18.9385 11.2496 18.8629 11.2496V11.25ZM11.639 9.34507C11.6256 9.35892 11.6204 9.3797 11.6256 9.39865C11.7107 9.7063 11.8063 9.98734 11.8559 10.2768C11.883 10.4346 11.9252 10.4721 12.0711 10.4714C13.3131 10.4659 14.5552 10.4685 15.7973 10.4678C15.8458 10.4678 15.8946 10.4641 15.952 10.4605C15.9797 10.4586 16.0015 10.435 16.0015 10.4062C16.0057 7.88302 15.0428 5.90373 12.9134 4.67387C10.7815 3.44292 8.61238 3.56066 6.59652 4.98735C4.7793 6.27334 3.97 8.13636 4.00375 10.4065C4.0041 10.432 4.02168 10.4539 4.04559 10.459C4.06527 10.4634 4.07969 10.4663 4.09375 10.4663C5.39453 10.467 6.69496 10.4663 7.99574 10.4696C8.11141 10.4696 8.12617 10.4113 8.13426 10.3139C8.19437 9.58783 8.55332 9.06039 9.16856 8.73342C9.7866 8.405 10.4001 8.46514 11.0125 8.82856C11.0329 8.84059 11.0589 8.83731 11.0758 8.82018C11.8158 8.05215 12.558 7.28267 13.2815 6.53215C13.3015 6.51137 13.3339 6.511 13.3546 6.53142C13.5104 6.68488 13.6629 6.83542 13.8278 6.99763C13.8493 7.01877 13.85 7.05412 13.8289 7.07563C13.0874 7.84365 12.3467 8.61095 11.6383 9.34471L11.639 9.34507ZM3.68348 4.59113C2.34684 6.28173 1.70594 8.214 1.75797 10.4051C1.75867 10.4346 1.78223 10.4583 1.8107 10.4583H3.19727C3.2268 10.4583 3.25 10.4331 3.2493 10.4025C3.20289 8.63063 3.70352 7.05048 4.75293 5.68284C4.76945 5.66133 4.7677 5.62998 4.74906 5.61066C4.41578 5.26547 4.09516 4.9334 3.76117 4.58712C3.73938 4.56452 3.70281 4.56598 3.68313 4.59077L3.68348 4.59113ZM15.2488 5.68721C16.3018 7.06324 16.7964 8.63865 16.7511 10.3978C16.7504 10.4284 16.7736 10.4535 16.8031 10.4535H18.1907C18.2192 10.4535 18.2427 10.4299 18.2434 10.4003C18.2902 8.20488 17.6518 6.27444 16.3179 4.59478C16.2982 4.56999 16.262 4.56853 16.2399 4.59113C15.9077 4.93596 15.5874 5.26803 15.2527 5.61504C15.2341 5.63436 15.2323 5.66571 15.2488 5.68721ZM9.55668 1.54456C7.51727 1.68562 5.77633 2.47551 4.32121 3.88981C4.29977 3.91095 4.29906 3.94668 4.32016 3.96818C4.65625 4.31811 4.97723 4.65273 5.30277 4.99136C5.32281 5.01214 5.3548 5.0125 5.37555 4.99246C6.5452 3.85664 7.95285 3.23114 9.56477 3.09336C9.59184 3.09117 9.61293 3.06784 9.61293 3.03941V1.59887C9.61293 1.56752 9.58691 1.54237 9.55668 1.54419V1.54456ZM15.7083 3.91679C14.223 2.47624 12.4806 1.68198 10.4468 1.54565C10.4166 1.54346 10.3909 1.56861 10.3909 1.60033V3.04123C10.3909 3.0693 10.412 3.09299 10.4391 3.09518C12.0598 3.2326 13.4664 3.86539 14.6554 5.02125C14.6761 5.0413 14.7081 5.04094 14.7282 5.02016C15.053 4.68262 15.3722 4.35165 15.6907 4.01994C15.6992 4.01119 15.7062 4.00172 15.715 3.98932C15.7308 3.96709 15.7284 3.93574 15.7087 3.91679H15.7083ZM11.0557 10.4605C11.0863 10.4605 11.1113 10.4331 11.1081 10.4014C11.0403 9.71651 10.5449 9.27545 9.90262 9.317C9.36086 9.352 8.89434 9.86085 8.8968 10.4054C8.8968 10.4357 8.92035 10.4605 8.94953 10.4605H11.0557Z'
        fill='var(--alternative-text-color)'
        stroke='var(--alternative-text-color)'
        strokeWidth='0.25'
      />
    </svg>
  );

  const genericIcon = (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
    >
      <path
        d='M15.75 9C15.75 5.27344 12.7265 2.25 8.99998 2.25C5.27342 2.25 2.24998 5.27344 2.24998 9C2.24998 12.7266 5.27342 15.75 8.99998 15.75C12.7265 15.75 15.75 12.7266 15.75 9Z'
        stroke='var(--alternative-text-color)'
        strokeWidth='1.5'
        strokeMiterlimit='10'
      />
      <path
        d='M12.3749 6.1875L7.64992 11.8125L5.62492 9.5625'
        stroke='var(--alternative-text-color)'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );

  const dailyIcon = (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
    >
      <path
        d='M12 15H6C5.40326 15 4.83097 14.7629 4.40901 14.341C3.98705 13.919 3.75 13.3467 3.75 12.75V5.25C3.75 5.05109 3.67098 4.86032 3.53033 4.71967C3.38968 4.57902 3.19891 4.5 3 4.5C2.80109 4.5 2.61032 4.57902 2.46967 4.71967C2.32902 4.86032 2.25 5.05109 2.25 5.25V12.75C2.25 13.7446 2.64509 14.6984 3.34835 15.4017C4.05161 16.1049 5.00544 16.5 6 16.5H12C12.1989 16.5 12.3897 16.421 12.5303 16.2803C12.671 16.1397 12.75 15.9489 12.75 15.75C12.75 15.5511 12.671 15.3603 12.5303 15.2197C12.3897 15.079 12.1989 15 12 15ZM7.5 9.75C7.5 9.94891 7.57902 10.1397 7.71967 10.2803C7.86032 10.421 8.05109 10.5 8.25 10.5H12C12.1989 10.5 12.3897 10.421 12.5303 10.2803C12.671 10.1397 12.75 9.94891 12.75 9.75C12.75 9.55109 12.671 9.36032 12.5303 9.21967C12.3897 9.07902 12.1989 9 12 9H8.25C8.05109 9 7.86032 9.07902 7.71967 9.21967C7.57902 9.36032 7.5 9.55109 7.5 9.75ZM15.75 6.705C15.7422 6.6361 15.7271 6.56822 15.705 6.5025V6.435C15.6689 6.35788 15.6208 6.287 15.5625 6.225L11.0625 1.725C11.0005 1.66666 10.9296 1.61856 10.8525 1.5825C10.8301 1.57932 10.8074 1.57932 10.785 1.5825C10.7088 1.53881 10.6247 1.51076 10.5375 1.5H7.5C6.90326 1.5 6.33097 1.73705 5.90901 2.15901C5.48705 2.58097 5.25 3.15326 5.25 3.75V11.25C5.25 11.8467 5.48705 12.419 5.90901 12.841C6.33097 13.2629 6.90326 13.5 7.5 13.5H13.5C14.0967 13.5 14.669 13.2629 15.091 12.841C15.5129 12.419 15.75 11.8467 15.75 11.25V6.75C15.75 6.75 15.75 6.75 15.75 6.705ZM11.25 4.0575L13.1925 6H12C11.8011 6 11.6103 5.92098 11.4697 5.78033C11.329 5.63968 11.25 5.44891 11.25 5.25V4.0575ZM14.25 11.25C14.25 11.4489 14.171 11.6397 14.0303 11.7803C13.8897 11.921 13.6989 12 13.5 12H7.5C7.30109 12 7.11032 11.921 6.96967 11.7803C6.82902 11.6397 6.75 11.4489 6.75 11.25V3.75C6.75 3.55109 6.82902 3.36032 6.96967 3.21967C7.11032 3.07902 7.30109 3 7.5 3H9.75V5.25C9.75203 5.50586 9.79768 5.75949 9.885 6H8.25C8.05109 6 7.86032 6.07902 7.71967 6.21967C7.57902 6.36032 7.5 6.55109 7.5 6.75C7.5 6.94891 7.57902 7.13968 7.71967 7.28033C7.86032 7.42098 8.05109 7.5 8.25 7.5H14.25V11.25Z'
        fill='var(--alternative-text-color)'
      />
    </svg>
  );

  return (
    <Grid item xs={12} sm={6} md={4}>
      <div className='vault-card-container'>
        <div
          className={
            caseData.status === 'complete'
              ? 'vault-card-icon-complete'
              : caseData.status === 'pending'
              ? 'vault-card-icon-pending'
              : 'vault-card-icon-draft'
          }
        >
          {caseData.docType === 'bulkScore'
            ? bulkIcon
            : caseData.docType === 'riskScore'
            ? scoreIcon
            : caseData.docType === 'report'
            ? genericIcon
            : dailyIcon}
        </div>
        <div className='vault-card-contents'>
          <h3>{caseData?.ticketName ? caseData.ticketName : 'Unnamed'}</h3>
          <p>
            {caseData?.entity?.firstName || caseData?.entity?.lastName
              ? `${caseData?.entity?.firstName} ${caseData?.entity?.lastName}`
              : caseData.entity?.companyName
              ? caseData.entity?.companyName
              : 'No entity info'}
          </p>
          <p>
            {caseData.commodities?.[0]?.commodityName
              ? caseData.commodities[0]?.commodityName
              : 'No commodity info'}
          </p>
          <p>{formatted_dt}</p>
          <Link
            to={`/analytics-vault/case/${caseData._id}`}
            className='vault-card-link'
          >
            Open
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='15'
              height='13'
              viewBox='0 0 15 13'
              fill='none'
            >
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M8.63144 12.2561C8.32278 11.9346 8.32278 11.4268 8.63144 11.1052L12.3124 7.31323H0.806427C0.359833 7.30908 0 6.9458 0 6.49927C0 6.05273 0.359833 5.68945 0.806427 5.6853H12.3064L8.62644 1.89526C8.31754 1.57324 8.31754 1.06494 8.62644 0.74292C8.77231 0.590088 8.97431 0.503906 9.18549 0.503906C9.39664 0.503906 9.5986 0.590332 9.74442 0.743164L14.7444 5.89819C14.9091 6.05396 15.0031 6.27026 15.0044 6.49683C15.0057 6.72339 14.9143 6.94092 14.7514 7.09839L9.74142 12.2603C9.59543 12.4126 9.39353 12.4988 9.18244 12.4988C8.97134 12.4988 8.76944 12.4126 8.62341 12.2603L8.63144 12.2561Z'
                fill='#4895EF'
              />
            </svg>
          </Link>
        </div>
      </div>
    </Grid>
  );
};

export default CaseCard;
